import React, { useState, useEffect } from 'react'
import { Users, TrendingUp } from 'lucide-react'
import { waitlistService } from '../lib/supabase'

export default function WaitlistStats() {
  const [stats, setStats] = useState({ totalSignups: 0 })
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await waitlistService.getWaitlistStats()
        setStats(data)
      } catch (error) {
        console.error('Error fetching waitlist stats:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchStats()
  }, [])

  if (isLoading) {
    return (
      <div className="flex items-center space-x-2 text-slate-400">
        <div className="w-4 h-4 bg-slate-600 rounded-full animate-pulse"></div>
        <span className="text-sm">Loading...</span>
      </div>
    )
  }

  return (
    <div className="flex items-center space-x-6 text-slate-400">
      <div className="flex items-center space-x-2">
        <div className="flex -space-x-2">
          {[1,2,3,4].map((i) => (
            <div key={i} className="w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-r from-pink-400 to-purple-500 rounded-full border-2 border-slate-900"></div>
          ))}
        </div>
        <span className="text-sm">{stats.totalSignups.toLocaleString()}+ people waiting</span>
      </div>
      <div className="flex items-center space-x-1">
        <TrendingUp className="h-4 w-4 text-green-400" />
        <span className="text-sm text-green-400">Growing daily</span>
      </div>
    </div>
  )
}